import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Controller, useFormContext } from 'react-hook-form';
import { setFormField } from '../../../store/reducers/registrationSlice';
import { useSelector } from 'react-redux';
import {defaultPhoneValidation, phoneValidationRules} from "../../../servics/phoneValidationRules";

const Step0PersonalInfo = ({ dispatch, formFields = {}, fields, translate, language_code}) => {
  const { control, register, setValue, formState: { errors } } = useFormContext();
  const iso2 = useSelector((s) => s.country.country?.value) || 'NG';
  const countryCode = iso2.toLowerCase();

  return fields.map(field => (
    <div key={field} className="mt-2">
      <label>{translate('signup', language_code.lang)[field]}</label>

      {field === 'telephone' ? (
        <Controller
          name="telephone"
          control={control}
          defaultValue={formFields.telephone || ''}
          rules={{
              required: 'Le téléphone est requis',
              validate: (value) => {
                  let digits = value.replace(/\D/g, '');

                  // 🔥 retirer indicatif pays
                  if (digits.startsWith("221")) digits = digits.slice(3);
                  if (digits.startsWith("223")) digits = digits.slice(3);
                  if (digits.startsWith("225")) digits = digits.slice(3);
                  if (digits.startsWith("226")) digits = digits.slice(3);
                  if (digits.startsWith("227")) digits = digits.slice(3);
                  if (digits.startsWith("228")) digits = digits.slice(3);
                  if (digits.startsWith("229")) digits = digits.slice(3);
                  if (digits.startsWith("233")) digits = digits.slice(3);
                  if (digits.startsWith("234")) digits = digits.slice(3);
                  if (digits.startsWith("237")) digits = digits.slice(3);

                  const rule = phoneValidationRules[iso2];

                  if (!rule) {
                      return defaultPhoneValidation.validate(value);
                  }

                  return rule.regex.test(digits) || rule.message;
              }
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <PhoneInput
              country={countryCode}
              value={value}
              onChange={phone => {
                onChange(phone); // met à jour RHF + déclenche la validation
                dispatch(setFormField({ field: 'telephone', value: phone }));
              }}
              onBlur={onBlur}
              inputProps={{ name: 'telephone', ref, required: true }}
            />
          )}
        />
      ) : field === 'isCooperative' ? (
        <select
          {...register('isCooperative', { required: 'Le champ est requis' })}
          defaultValue={formFields.isCooperative || ''}
          onChange={e => {
            setValue('isCooperative', e.target.value, { shouldValidate: true });
            dispatch(setFormField({ field: 'isCooperative', value: e.target.value }));
          }}
        >
          <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
          <option value="true">{translate('signup', language_code.lang).yes}</option>
          <option value="false">{translate('signup', language_code.lang).no}</option>
        </select>
      ) : (
        <input
        type={field === 'email' ? 'email' : 'text'}
        {...register(field, { 
          required: 'Ce champ est requis',
          ...(field === 'email' && {
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Regex basique email
              message: 'Adresse email invalide'
            }
          })
        })}
        defaultValue={formFields[field] || ''}
        onChange={e => {
          setValue(field, e.target.value, { shouldValidate: true });
          dispatch(setFormField({ field, value: e.target.value }));
        }}
      />
      )}
      {errors[field] && <p className="text-danger">{errors[field].message}</p>}
    </div>
  ));
};

export default Step0PersonalInfo;
